import { USER_AUTHENTICATED } from '../constants/actionTypes';

export function userAuthenticated(authKey) {
  return { type: USER_AUTHENTICATED, authKey };
}
export const appDefaultState = {
  authKey: null,
  now: Date.now(),
};

export default function appStateReducer(state = appDefaultState, action = {}) {
  switch (action.type) {
    case USER_AUTHENTICATED:
      return { ...state, authKey: action.authKey };
    default:
      return state;
  }
}
